<template>
  <div class="drawer_main">
    <a-drawer
      :title="`${isSystemEdit ? modalTit + roles.rolename : title }`"
      :width="720"
      :visible="roleDrawerVisible"
      :mask-closable="false"
      wrap-class-name="filter-drawer-group pc_role_drawer"
      @close="onClose"
    >
      <a-form
        :form="form"
        style="margin-top:-24px; margin-bottom:50px;"
        hide-required-mark
      >
        <a-alert
          v-if="showAlert"
          :message="alertTip"
          type="info"
          show-icon
          class="role-define-tip"
        />
        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          :label="`${roleNameTit}：`"
        >
          <template v-if="isSystemEdit">
            <span
              class="role-name-span marginl16"
            >{{ roles.rolename }}</span><span class="role-name-span-content">{{ roleManageDesc[roles.roleid] }}</span>
          </template>
          <div
            v-else
            class="role_name"
          >
            <a-input
              v-decorator="['rolename', { initialValue: roles.rolename, rules: [{ required: true, validator: roleValidate }] }]"
              :maxlength="5"
              class="marginl16"
              @change.stop="handleRole"
            />
            <span class="input_suffix">{{ roles.rolename ? (roles.rolename.length >= 5 ? 5 : roles.rolename.length) : 0 }}/5</span>
          </div>
        </a-form-item>
        <a-form-item
          v-for="(item, index) in newDatas"
          :key="item.id"
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          :label="item.name"
        >
          <template v-if="item.id * 1 === 777777701 && item.child.length > 0">
            <div
              v-for="item2 in item.child"
              :key="item2.id"
              class="check-item margin-left-20"
            >
              <div>
                <a-checkbox
                  :checked="item2.selected"
                  :disabled="!item2.cancel"
                  @change="handelCancel($event,item2)"
                >
                  {{ item2. name }}

                  <!-- 信息接待关联线索管理提示，当禁止时候出现-->
                  <a-popover
                    v-if="item2.id === 125 && !item2.cancel"
                    placement="topRight"
                    overlay-class-name="universal-tips-pop"
                  >
                    <template slot="content">
                      <p>本权限需要本角色有信息接待（信息录入）权限才可开启</p>
                    </template>
                    <i class="iconfont iconicon-test31" />
                  </a-popover>
                </a-checkbox>
              </div>
              <div
                v-if="item2.child && item2.child.length > 0"
                class="margin-left-20 check-item-children"
              >
                <a-checkbox
                  v-for="item3 in item2.child"
                  :key="item3.id"
                  :checked="item3.selected"
                  :disabled="!item3.cancel"
                  @change="handelCancel($event,item3)"
                >
                  {{ item3. name }}
                </a-checkbox>
              </div>
            </div>
          </template>
          <template v-else>
            <div
              v-for="(item2, index2) in (item.id === 25 ? baseDatas.child: item.child)"
              :key="item2.id"
              class="check-item margin-left-20"
            >
              <template v-if="item2.child && item2.child.length > 0 ">
                <label
                  class="check-tit"
                  :class="{diasbled: !item2.cancel}"
                >{{ item2.name }}</label>
                <a-checkbox
                  :indeterminate="item2.indeterminate"
                  :disabled="!item2.cancel"
                  :checked="item2.selected"
                  class="check-all-btn"
                  @change="onCheckAllChange($event, item2, (item.id === 25 ? baseDatas: item), index, index2)"
                >
                  {{ $t('message["1893"]') }}
                </a-checkbox>
                <a-checkbox-group
                  :value="item2.defaultValue"
                  class="margin-left-20 check-item-children"
                  @change="onChange($event, item2, (item.id === 25 ? baseDatas: item), index)"
                >
                  <a-checkbox
                    v-for="item3 in item2.child"
                    :key="item3.id"
                    :disabled="!item3.cancel"
                    :value="item3.id"
                  >
                    {{ item3. name }}
                    <a-popover
                      v-if="item3.tips"
                      placement="topLeft"
                      overlay-class-name="universal-tips-pop"
                    >
                      <template slot="content">
                        <p>{{ item3.tips }}</p>
                      </template>
                      <i class="iconfont iconicon-test31" />
                    </a-popover>
                  </a-checkbox>
                </a-checkbox-group>
              </template>
              <template v-else>
                <a-checkbox
                  :checked="item2.selected"
                  :disabled="!item2.cancel"
                  @change="onCheckAllChange($event, item2, (item.id === 25 ? baseDatas: item), index, index2)"
                >
                  {{ item2. name }}
                </a-checkbox>
              </template>
            </div>
          </template>
        </a-form-item>
      </a-form>
      <div
        v-if="!hideOperate"
        class="event-footer-div"
      >
        <a-button
          type="primary"
          class="save-btn"
          :disabled="isSaveDisableabled"
          :loading="rolemanageLoading"
          @click="onSave"
        >
          {{ $t('message["21"]') }}
        </a-button>
        <a-button @click="onClose">
          {{ $t('message["896"]') }}
        </a-button>
        <a-button
          v-if="editType === 'defineRoleEdit'"
          style="background: #F57676; color: #fff"
          @click.stop="deleteRoles"
        >
          {{ $t('message["962"]') }}
        </a-button>
      </div>
    </a-drawer>
  </div>
</template>
<script>
import { cloneDeep } from 'lodash'
import { mapState, mapActions, mapMutations } from 'vuex'
const formItemLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 20 }
}

// new
const BASE_ID = 777777701
const INFO_EDIT_INDEX = 25 // 信息编辑权限
const REVIEW_CONTENT_PARENT_INDEX = 43 // 信息查看权限
const INFO_DETAIL_INDEX = 85 // 信息编辑 信息详情权限
const SEE_INFO_DETAIL_INDEX = 15 // 信息查看权限 信息详情权
const OTHER_ID = 777777702 // 其他选项
const ids = [81, 1, 12, 2] // 监控这些是否有选中
// const SALES_SYSTEM_ROLE = 5 // 销售
// 数据对照, 信息查看模块对照下面编辑权限模块
const idDatas = {
  18: [122], // 基础信息：推广方式id => 基础信息：推广方式id
  19: [27], // 基础信息：信息分级id => 基础信息：信息分级id
  20: [28, 121], // 基础信息：信息类型id => 基础信息：信息类型id和备案id，
  21: [29], // 基础信息：跟进状态id => 基础信息：跟进状态id
  32: [113], // 来源详情id => 来源详情id
  33: [40, 41, 42], // 回访记录id => 新增回访id和删除回访id 设置回访提醒id
  34: [36, 120] // 评论内容id => 新增评论id和删除id
}
export default {
  props: {
    roleInfo: {
      type: Object,
      default: () => { }
    },
    editType: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      permissionDatas: [],
      formItemLayout,
      roles: {
      },
      indeterminate: false,
      checkAll: false,
      visible: false,
      hideOperate: false,
      form: this.$form.createForm(this),
      // 判断【信息开发权限】|【信息接待权限】是否被选中，用于禁用【推广方式】
      titName: ''
    }
  },
  computed: {
    ...mapState('role', ['roleDrawerVisible', 'rolemanageLoading', 'permissionList', 'roleManageDesc', 'showNotification']),
    isRoleType () {
      return this.roles.system_role
    },
    showAlert () {
      return this.roleInfo && Object.keys(this.roleInfo).length === 0
    },
    isSystemEdit () {
      return this.editType === 'systemRoleEdit'
    },
    alertTip () {
      return this.$t('message["1256"]')
    },
    modalTit () {
      return this.$t('message["413"]')
    },
    title () {
      const { rolename } = cloneDeep(this.titName)
      // console.log(this.roleInfo)
      return rolename ? `${this.$t('message["413"]')}${rolename}` : this.$t('message["414"]')
    },
    roleNameTit () {
      return this.$t('message["506"]')
    },
    roleManageTit () {
      return this.$t('message["507"]')
    },
    delMemberTip () {
      return this.$t('message["161"]').split('|')
    },
    idKeyDatas () {
      const { newDatas } = this
      let viewInfoArr = []
      let editInfoArr = []
      newDatas.forEach(item => {
        // 查看权限 信息详情
        if (item.id === REVIEW_CONTENT_PARENT_INDEX) {
          viewInfoArr = item.child.filter(item2 => item2.id === SEE_INFO_DETAIL_INDEX)[0]
        } else if (item.id === INFO_EDIT_INDEX) { // 编辑权限 信息详情
          editInfoArr = item.child.filter(item2 => item2.id === INFO_DETAIL_INDEX)[0]
        }
      })
      viewInfoArr.child.forEach(item => {
        for (let i = 0; i < editInfoArr.child.length; i++) {
          const item2 = editInfoArr.child[i]
          if (item.name === item2.name) {
            idDatas[item.id] = [item2.id]
            break
          }
        }
      })
      return idDatas
    },
    // 基本权限数据
    baseDatas () {
      let arr = cloneDeep(this.newDatas).find(item => item.id === INFO_EDIT_INDEX)
      return arr
    },
    // 编辑权限索引
    editIndex () {
      return this.newDatas.findIndex(item2 => item2.id === INFO_EDIT_INDEX)
    },
    // 处理好初始化数据
    newDatas () {
      const { permissionList = [] } = this
      // const datas = cloneDeep(permissionList)
      permissionList.forEach(item => {
        if (item.id === BASE_ID) {
          if (item.child && item.child.length > 0) {
            item.child.forEach(item2 => {
              item2.child = this.setChildDisabled(item2)
            })
          }
        }
      })
      return permissionList
    },
    // 选中id
    selectIds () {
      let baseArr = []
      this.newDatas.forEach(item => {
        if (item.id === BASE_ID || (item.id === OTHER_ID)) {
          if (item.child && item.child.length > 0) {
            item.child.forEach(item2 => {
              if (ids.includes(item2.id)) {
                if (item2.selected) {
                  baseArr.push(item2.id)
                }

                // 信息接待权限关联线索管理权限

                if (item2.id === 1) {
                  item.child.forEach(item3 => {
                    if (item3.id === 125) {
                      item3.cancel = item2.selected
                      if (!item2.selected) {
                        item3.selected = false
                      }
                    }
                  })
                }
              }
            })
          }
        }
      })
      return baseArr
    },
    allSelectedIds () {
      let selectedId = []
      this.newDatas.forEach(item => {
        if (Array.isArray(item.child)) {
          item.child.map(value => {
            const childrenId = []
            if (value.child && value.child.length > 0) {
              value.child.forEach(item2 => {
                if (item2.selected) {
                  childrenId.push(item2.id)
                }
              })
            }
            if (value.selected || childrenId.length > 0) {
              selectedId.push(value.id)
            }
            selectedId = selectedId.concat(childrenId)
            // selectedId = selectedId.concat(value.defaultValue)
          })
        }
      })
      return selectedId
    },
    // 判断选中id是否包含【信息开发权限】【信息接待权限】【信息审核权限】【信息录入权限】【信息跟进权限】【EDM营销】之中的一项
    isSaveDisableabled () {
      const { allSelectedIds = [] } = this
      const hasIdArr = [81, 1, 2, 3, 12]
      return !(allSelectedIds.length > 0 && allSelectedIds.some(item => hasIdArr.includes(item)))
    }
  },
  watch: {
    roleInfo (val) {
      if (!val) return
      this.titName = cloneDeep(val)
      this.roles = cloneDeep(val)
      if (!this.roles.rolename) {
        this.roles.rolename = ''
      }
      if (val.system_role === 1 || val.system_role === 2) {
        this.hideOperate = true
      } else {
        this.hideOperate = false
      }
    },
    newDatas: {
      handler (val) {
        const { isRoleType = 0 } = this
        if (isRoleType !== 1 && (isRoleType !== 2)) {
          val.forEach((item, index) => {
            const isSelected = this.selectIds.length > 0
            if (item.id === REVIEW_CONTENT_PARENT_INDEX) {
              item.child = this.handleDatas(item)
              this.baseDatas.child = this.handleDatas(this.baseDatas)
              if (isSelected > 0) {
                item.child.forEach(item2 => {
                  if (item2.cancel) {
                    if (Object.keys(this.idKeyDatas).includes(item2.id + '')) {
                      this.setSomeDisabled(item2.id, item2.selected, index)
                    } else {
                      const childArr = item2.child
                      if (childArr && childArr.length > 0) {
                        childArr.forEach(item3 => {
                          if (Object.keys(this.idKeyDatas).includes(item3.id + '')) {
                            this.setSomeDisabled(item3.id, item3.selected, index)
                          }
                        })
                      }
                    }
                  }
                })
              }
            } else if (item.id !== BASE_ID && item.id !== INFO_EDIT_INDEX) {
              item.child.forEach(item2 => {
                item2 = this.setChildValues(item2, true)
              })
            }
          })
        } else {
          val.forEach(item => {
            item.child.forEach(item2 => {
              if (item2.child && item2.child.length > 0) {
                item2.defaultValue = item2.child.filter(item3 => item3.selected).map(item4 => item4.id)
              }
            })
          })
        }
      },
      deep: true
    },
    baseDatas: {
      handler (val) {
        this.newDatas[this.editIndex] = cloneDeep(val)
        let addNewRecord = val.child.filter(item => item.id === 40)
        val.child.forEach(item => {
          if (item.id === 42) {
            item.cancel = addNewRecord[0].cancel && addNewRecord[0].selected
            if (!addNewRecord[0].selected) {
              item.selected = false
            }
          }
        })
      },
      deep: true
    },
    showNotification (val) {
      val && this.openInfoRepeatNotification()
      // 初始化
      val && this.setShowNotification(false)
    }
  },
  mounted () {
    if (this.roleInfo) {
      this.roles = cloneDeep(this.roleInfo)
    }
  },
  destroyed () {
    this.setRoleDrawerVisible(false)
  },
  methods: {
    ...mapActions('role', ['changeRoleManageVisible', 'fetchUpdatePermissionDatas', 'fetchAddRole', 'fetchEditRole', 'fetchDeleteRole']),
    ...mapMutations('role', ['setRoleDrawerVisible', 'setShowNotification', 'SET_ADD_ROLE_VISIBLE', 'DEL_ROLE_LIST']),
    onClose () {
      this.changeRoleManageVisible(false)
    },
    // 基本业务权限操作 设置子元素是否禁止
    setChildDisabled (parent) {
      if (parent.child && parent.child.length > 0) {
        return parent.child.map(item => {
          const { isRoleType = 0 } = this
          if (isRoleType !== 1 && (isRoleType !== 2)) {
            item.cancel = parent.selected
          }

          if (!parent.selected) {
            item.selected = parent.selected
          }
          return item
        })
      }
    },

    // 除基本业务权限模块的，子元素值设置
    setChildValues (parent, checked, isView) {
      if (parent.child && parent.child.length > 0) {
        parent.defaultValue = []
        const optionsLen = parent.child.length
        parent.child.forEach(item => {
          if (isView) {
            // item.cancel = checked
            this.$set(item, 'cancel', checked)
          }
          if (!checked) {
            // item.selected = false
            this.$set(item, 'selected', false)
          }
        })
        this.$set(parent, 'defaultValue', parent.child.filter(item2 => item2.selected).map(item3 => item3.id))
        parent.selected = optionsLen === parent.defaultValue.length
        parent.indeterminate = parent.defaultValue.length > 0 && (optionsLen !== parent.defaultValue.length)

        parent.cancel = !parent.child.every(item => !item.cancel)
      } else {
      }
      return parent
    },
    // 特定状态下设置关联禁止状态
    setSomeDisabled (id, checked, index) {
      let arr = this.idKeyDatas[id]
      if (arr && arr.length > 0) {
        arr.forEach(item => {
          for (let i = 0; i < this.baseDatas.child.length; i++) {
            const item2 = this.baseDatas.child[i]
            if (item2.id === item) {
              item2.cancel = checked
              if (!checked) {
                item2.selected = false
              }
              break
            } else {
              const childArr = item2.child
              if (childArr && childArr.length > 0) {
                for (let j = 0; j < childArr.length; j++) {
                  const item3 = childArr[j]
                  if (item3.id === item) {
                    if (!checked) {
                      item3.selected = false
                    }
                    item3.cancel = checked
                  }
                }
                item2.cancel = !childArr.every(item4 => !item4.cancel)
              }
            }
          }
        })
      }
      // console.log(this.baseDatas)
    },
    // 基本业务权限处理
    handelCancel (e, item) {
      item.selected = e.target.checked
    },
    // 处理禁止
    handleDatas (item) {
      const IsselectIdsLen = this.selectIds.length > 0
      if (item.child && item.child.length > 0) {
        item.child.forEach(item2 => {
          if (item2.child && item2.child.length > 0) {
            item2 = this.setChildValues(item2, IsselectIdsLen, true)
          } else {
            if (!IsselectIdsLen) {
              item2.selected = IsselectIdsLen
            }
            item2.cancel = item2.id === 32 && this.isRoleType === 3 ? false : IsselectIdsLen
          }
        })
      }

      return item.child
    },
    onSave () {
      let permission = this.allSelectedIds
      if (permission.length === 0) {
        this.$message.warning(this.$t('message["508"]'))
        return
      }
      let params = { rolename: this.roles.rolename, permission }
      if ((this.editType === 'addRole')) {
        // 新增
        this.fetchAddRole(params)
      } else if (this.editType === 'defineRoleEdit') {
        // 管理更新
        params = Object.assign(params, { roleid: this.roles.roleid })
        this.fetchEditRole(params)
      } else if (this.isSystemEdit) {
        params = Object.assign(params, { roleid: this.roles.roleid })
        this.fetchUpdatePermissionDatas(params)
      }
    },
    // 信息查重开启提示【repeatState】
    openInfoRepeatNotification () {
      const key = this.roles.roleid
      const btn = <div>
        <a-button type="primary" size="small" onClick={() => this.toInfoRepeat(key)}>{this.$t('message["598"]')}</a-button>
        <a-button size="small" onClick={() => this.colseNotification(key)}>{ this.$t('message["1004"]')}</a-button>
      </div>
      this.$notification['warning']({
        message: this.$t('message["1356"]'),
        description: this.$t('message["1290"]'),
        btn,
        key,
        class: 'role-notification'
      })
    },
    colseNotification (key) {
      this.$notification.close(key)
    },
    toInfoRepeat (key) {
      this.colseNotification(key)
      this.$router.push({ name: 'configRepeat' })
    },
    // 除基本业务单个选中
    onChange (e, item, parent, index) {
      item.child.forEach(item2 => {
        item2.selected = e.includes(item2.id)
      })

      if (parent.id === INFO_EDIT_INDEX) {
        item = this.setChildValues(item, true)
        this.$set(this.newDatas, index, this.baseDatas)
      }
      // this.$forceUpdate()
      // const index2 = this.newDatas.findIndex(item2 => item2.id === INFO_EDIT_INDEX)
      this.$set(this.newDatas, this.editIndex, this.baseDatas)
    },
    onCheckAllChange (e, item, parent, index, index2) {
      const isChecked = e.target.checked
      if (item.child && item.child.length > 0) {
        item.child.forEach(item2 => {
          if (item2.cancel) {
            item2.selected = isChecked
          }
        })
        if (parent.id === INFO_EDIT_INDEX) {
          item = this.setChildValues(item, isChecked)
        }
      } else {
        item.selected = isChecked
      }

      if (parent.id === INFO_EDIT_INDEX) {
        this.$set(this.baseDatas.child, index2, item)
        this.$set(this.newDatas, index, this.baseDatas)
      }
    },
    // 验证自定义角色
    roleValidate (rule, value, callback) {
      value = value.trim()
      let length = value.length
      if (length === 0) {
        callback(new Error(this.$t('message["779"]')))
      }
      callback()
    },
    handleRole (e) {
      const { value } = e.target
      this.roles['rolename'] = value
    },
    deleteRolesFail () {
      const title = <span class='del_title'>{ this.$t('message["975"]') }</span>
      const _this = this
      this.$confirm({
        title,
        iconType: 'exclamation-circle',
        closable: true,
        content: <p><span style="color: #F57676">{this.delMemberTip[0]}</span>{this.delMemberTip[1]}</p>,
        okText: this.$t('message["598"]'),
        cancelText: this.$t('message["1005"]'),
        onOk () {
          _this.$router.push({ name: 'TeamIndex' })
        },
        onCancel () {
        },
        class: 'del_model del_fail_model'
      })
    },
    // 删除自定义的角色
    deleteRoles () {
      const title = <span class='del_title'>{this.$t('message["491"]') }<a-tag>{this.roles.rolename}</a-tag></span>
      const _this = this
      this.$confirm({
        class: 'del_model',
        title: title,
        iconType: 'exclamation-circle',
        closable: true,
        content: <span style="color: #666">{this.$t('message["1520"]') }？</span>,
        async onOk () {
          const chain = await _this.fetchDeleteRole({ roleid: _this.roles.roleid })
          chain.onSuccess(payload => {
            _this.DEL_ROLE_LIST(_this.roles.roleid)
            _this.SET_ADD_ROLE_VISIBLE(false)
            _this.setRoleDrawerVisible(false)
            _this.roles.rolename = ''
            _this.form.resetFields()
          })
            .onFail(() => {
              _this.deleteRolesFail()
            })
            .fetch()
        },
        onCancel () {
          // console.log('Cancel')
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.ant-input ::v-deep {
  width: 240px
}
.role_name {
  position: relative;
  display: inline-block;
}
.input_suffix {
  position: absolute;
  display: inline-block;
  right: 0;
  padding: 0 12px;
  border-left: 1px solid #D6D6D6;
  color: #D6D6D6;
  font-size: 18px;
}
.role-define-tip {
  margin-bottom: 24px;
}
.marginl16 {
  margin-left: 16px;
}
.margint16 {
  // margin-top: 16px;
}
.marginl100 {
  // margin-left: 174px
}
.role-name-span {
  height: 24px;
  font-size: 14px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 24px;
}
.role-name-span-content {
  margin-left: 16px;
  height: 24px;
  font-size: 14px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(179, 179, 179, 1);
  line-height: 24px;
}
.check-item {
  margin-bottom: 8px;
  .check-item-children{
    padding-bottom: 8px;
  }
}
.save-btn {
  margin-left: 150px;
  margin-right: 8px;
}
.event-footer-div {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 703px;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: left;
  z-index: 110;
}
.margin-left-20 {
  margin-left: 20px;
}
.check-tit {
  margin-right: 9px;
}
.diasbled{
  color: rgba(0, 0, 0, 0.25);
}
.check-all-btn {
  color: #5077aa;
}
.check-item::v-deep {
  .check-all-btn.ant-checkbox-wrapper-disabled span {
    color:rgba(80,119,170, 0.5) !important ;
  }
}
.float-div {
  float: left;
  // width: 220px;
  // position: absolute;
  // left: 16px;
  // margin-top: 10px;
}
.float {
  float: left;
}
.margin-normal {
  margin-bottom: 0;
}
.normal-div:first-of-type {
  margin-top: 0;
}
.normal-div,
.margin-left-32 {
  // min-height: 24px;
}
</style>
<style lang="scss">
.role-notification {
  .ant-notification-notice-btn {
    float: left;
    margin-left: 45px;
  }
}
.pc_role_drawer {
  .ant-drawer-header {
    // height: 56px;
    padding-left: 40px !important;
    .ant-drawer-title {
      margin: 16px 0;
      line-height: 56px;
    }
  }
  .ant-drawer-body {
    padding-left: 40px !important;
  }
  .ant-drawer-close {
    top: 38px !important;
  }
  label.ant-checkbox-wrapper {
    margin-bottom: 0;
    line-height: 32px;
  }
   i.iconicon-test31 {
    color: #d6d6d6;
  }
}
</style>
